import React, { useLayoutEffect, useRef, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const COLLAPSED_LINES = 2;

// Ratings datatable'ında uzun yorumlar kesilmesin diye: kapalıyken 2 satıra
// "clamp"lenir, taşma varsa "Show more / Show less" ile açılıp tam metni
// gösterir. Taşma, ref ile ölçülür (clamp'liyken scrollHeight > clientHeight).
// `expanded` deps'te çünkü clamp stili değişince yeniden ölçüm gerekir.
const CommentCell = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return undefined;
    const measure = () =>
      setOverflowing(el.scrollHeight - el.clientHeight > 1);
    measure();
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(measure);
      ro.observe(el);
    }
    return () => ro?.disconnect();
  }, [text, expanded]);

  if (!text) {
    return <span className="text-slate-300 dark:text-slate-600">—</span>;
  }

  const clampStyle = expanded
    ? undefined
    : {
        display: '-webkit-box',
        WebkitLineClamp: COLLAPSED_LINES,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
      };

  return (
    <div className="min-w-[12rem] max-w-[22rem]">
      <p
        ref={textRef}
        style={clampStyle}
        className="whitespace-pre-line break-words text-sm leading-snug text-slate-600 dark:text-slate-300"
      >
        {text}
      </p>
      {overflowing || expanded ? (
        <button
          type="button"
          aria-expanded={expanded}
          onClick={(e) => {
            e.stopPropagation();
            setExpanded((v) => !v);
          }}
          className="mt-1 inline-flex items-center gap-0.5 text-xs font-semibold text-blue-600 transition hover:underline dark:text-sky-400"
        >
          {expanded ? 'Show less' : 'Show more'}
          <ChevronDownIcon
            className={
              'h-3 w-3 transition-transform duration-200 ' +
              (expanded ? 'rotate-180' : '')
            }
            aria-hidden="true"
          />
        </button>
      ) : null}
    </div>
  );
};

export default CommentCell;
